/* eslint-disable react/no-unknown-property */
import { PageProps } from '@/types';
import { Head, usePage } from '@inertiajs/react';

/**
 * A drop-in replacement for Inertia.js's <Head /> that appends the app name after the title.
 */
export function AppHead({ children }: { children?: React.ReactNode }) {
    const {
        props: { meta },
    } = usePage<PageProps>();

    return (
        <Head title={meta.title}>
            {/* @ts-expect-error react/no-unknown-property */}
            <meta inertia property='og:title' content={meta.title} />
            {/* @ts-expect-error react/no-unknown-property */}
            <meta inertia name='twitter:title' content={meta.title} />

            {/* @ts-expect-error react/no-unknown-property */}
            <meta inertia name='description' content={meta.description}></meta>
            {/* @ts-expect-error react/no-unknown-property */}
            <meta inertia property='og:description' content={meta.description} />
            {/* @ts-expect-error react/no-unknown-property */}
            <meta inertia name='twitter:description' content={meta.description} />

            {/* @ts-expect-error react/no-unknown-property */}
            <meta inertia property='og:url' content={window.location.toString()} />
            {/* @ts-expect-error react/no-unknown-property */}
            <meta inertia property='twitter:url' content={window.location.toString()} />
            {/* @ts-expect-error react/no-unknown-property */}
            <meta inertia property='twitter:domain' content={window.location.hostname} />

            {children}
        </Head>
    );
}
